import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShiftService } from '../../shift.service';

@Component({
  selector: 'app-shift-bagdes',
  templateUrl: './shift-batch.component.html',
  styleUrls: ['./shift-batch.component.scss']
})
export class ShiftBatchComponent implements OnInit {
  shiftBatchDetail: any = [];
  did: number;
  id: string;
  public href = '';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private shiftServices: ShiftService
  ) { }

  ngOnInit() {
    this.href = this.router.url;
    this.id = this.href.split('/')[3];
    // tslint:disable-next-line: radix
    this.did = parseInt(this.id);
    this.getShiftDetail();
  }
  getShiftDetail() {
    this.shiftServices.getBatchByShiftId(this.did).subscribe(Response => {
      this.shiftBatchDetail = Response;
      console.log(' shift batch detail with Id', this.shiftBatchDetail);
    });
  }
  isAllow(id) {
    debugger;
    console.log(id);
  }

}
